/* @flow */

import React, { Component } from 'react';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';
import Immutable from 'immutable';
import moment from 'moment';
import uuid from 'uuid';
import { Segment } from 'semantic-ui-react';
import Navigation from './Navigation';
import MySpaceDocuments from './components/MySpaceDocuments';
import MySpaceEvents from './components/MySpaceEvents';
import * as API from './api';
import { storeSuccess } from 'plugins/toastr';
import type { MySpaceDocument, MySpaceEvent } from './types';

type Props = {
  user: string,
};

type State = {
  isFetching: boolean,
  isSaving: boolean,
  spaceId?: string,
  docs: List<MySpaceDocument>,
  events: Array<MySpaceEvent>,
};

const mapDocsToState = blocks =>
  Immutable.Map(blocks.map(b => [b.order, b]))
    .sortBy(b => b.order)
    .toList();

const addDocument = (type, content, docs) => {
  const doc = {
    id: uuid(),
    order: docs.size,
    isNew: true,
    date: moment().format('DD/MM/YYYY'),
    type,
    ...content,
  };

  return docs.push(doc);
};

class App extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      isFetching: false,
      isSaving: false,
      docs: Immutable.List(),
      events: [],
    };
  }

  componentDidMount() {
    const { user } = this.props;

    this.setState({
      isFetching: true,
    });

    API.get(user).then(({ docs, events, spaceId }) =>
      this.setState({
        spaceId,
        docs: mapDocsToState(docs),
        events,
        isFetching: false,
      })
    );
  }

  addDocument = (type, content) => {
    this.setState(prevState => ({
      docs: addDocument(type, content, prevState.docs),
    }));
  };

  updateDocuments = (docs: List<MySpaceDocument>) => {
    this.setState({
      docs,
    });
  };

  deleteEvent = (event: MySpaceEvent) => {
    API.deleteEvent(event.id).then(_ => {
      // Storing success notification
      storeSuccess('Suppression effectuée avec succès');

      // Reloading page
      window.location.reload(true);
    });
  };

  onSave = () => {
    const { user } = this.props;
    const { docs, spaceId } = this.state;

    this.setState({ isSaving: true });

    const contextualizedDocs = docs.map(d => ({
      ...d,
      spaceId,
    }));

    API.save(user, contextualizedDocs).then(docs =>
      this.setState({ docs: mapDocsToState(docs), isSaving: false })
    );
  };

  render() {
    const { user } = this.props;
    const { isFetching, isSaving, docs, events } = this.state;

    if (isFetching) {
      return <Segment loading style={{ minHeight: '180px' }} />;
    }

    return (
      <div style={{ paddingBottom: '25px' }}>
        <HashRouter>
          <div>
            <Navigation
              user={user}
              isSaving={isSaving}
              onAddDocument={this.addDocument}
              onSave={this.onSave}
            />
            <Switch>
              <Route
                exact
                path="/"
                render={() => <Redirect to="/documents" />}
              />
              <Route exact path="/documents">
                <MySpaceDocuments docs={docs} onUpdate={this.updateDocuments} />
              </Route>
              <Route exact path="/events">
                <MySpaceEvents events={events} onDelete={this.deleteEvent} />
              </Route>
            </Switch>
          </div>
        </HashRouter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/modules/my-space/App.js